import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Spinner } from "@/components/bits";
import { Building2, Ticket, TicketCheck, Users } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => setStats({}));
  }, []);

  if (!stats) return <Spinner />;

  const cards = [
    { label: "Tenants Ativos", value: stats.tenants_active, icon: Building2, accent: "text-emerald-400 bg-emerald-400/10" },
    { label: "Tenants Suspensos", value: stats.tenants_suspended, icon: Building2, accent: "text-rose-400 bg-rose-400/10" },
    { label: "Chamados em Aberto", value: stats.tickets_open, icon: Ticket, accent: "text-amber-400 bg-amber-400/10" },
    { label: "Total de Chamados", value: stats.tickets_total, icon: TicketCheck, accent: "text-indigo-400 bg-indigo-400/10" },
    { label: "Usuários na Plataforma", value: stats.users_total, icon: Users, accent: "text-sky-400 bg-sky-400/10" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <PageHeader title="Visão Global" subtitle="Panorama da plataforma em tempo real" />
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {cards.map(({ label, value, icon: Icon, accent }) => (
          <div key={label} className="bg-zinc-900 border border-zinc-800 rounded-md p-4" data-testid={`stat-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}>
            <div className={`h-8 w-8 rounded-md flex items-center justify-center mb-3 ${accent}`}>
              <Icon className="h-4 w-4" />
            </div>
            <p className="text-2xl font-semibold text-zinc-100">{value ?? "—"}</p>
            <p className="text-xs text-zinc-500 mt-1">{label}</p>
          </div>
        ))}
      </div>
      <div className="mt-8 bg-zinc-900 border border-zinc-800 rounded-md p-6">
        <h2 className="text-lg font-medium text-zinc-100 mb-2">Gerenciamento de Tenants</h2>
        <p className="text-sm text-zinc-400 mb-4">Crie empresas assinantes, gere chaves de API e controle o status da assinatura.</p>
        <Link to="/admin/tenants" data-testid="go-to-tenants-link"
          className="inline-flex items-center gap-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm rounded-md px-4 py-2 transition-colors duration-200">
          <Building2 className="h-4 w-4" /> Gerenciar Tenants
        </Link>
      </div>
    </div>
  );
}
